import { FormEvent, useState } from 'react'
import { smText } from '../../../style/text'

const Login = ({ setStage }: any) => {

    const [form, setForm] = useState({
        email: '',
        password: ''
    })

    const [error, setError] = useState({
        email: false,
        password: false
    })

    const handleLogin = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        if (!form.email || form.email !== 'joses.maint@gmail.com') {
            setError({
                email: true,
                password: false
            })
        } else if (!form.password || form.password !== 'Login1974') {
    
            setError({
                email: false,
                password: true
            })
        } else {
            setForm({ email: '', password: '' })
            setError({ email: false, password: false })
            setStage('token')
        }
    }

    return (
        <div className='w-[400px]'>
            <p className={`${smText} font-medium`}>Login</p>
            <form className='flex flex-col gap-5 py-7' onSubmit={handleLogin}>
                <div className='flex flex-col gap-2' >
                    <label htmlFor="email" className='flex gap-1' >
                        <p className='opacity-70'>Email Address</p>
                        <p className='text-red-600'>*</p>
                    </label>
                    <input
                        value={form.email}
                        onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
                        type="email"
                        name='email'
                        className='border border-1 focus:outline-none p-1'
                        style={{
                            borderColor: error.email ? '#f87171' : '#000000',
                            color: error.email ? '#f87171' : '#000000'
                        }}
                    />
                </div>
                <div className='flex flex-col gap-2'>
                    <label htmlFor="password" className='flex gap-1' >
                        <p className='opacity-70'>Password</p>
                        <p className='text-red-600'>*</p>
                    </label>
                    <input
                        value={form.password}
                        onChange={(e) => setForm((prev) => ({ ...prev, password: e.target.value }))}
                        type="text" name='password'
                        className='border border-1 focus:outline-none p-1'
                        style={{
                            borderColor: error.password ? '#f87171' : '#000000',
                            color: error.password ? '#f87171' : '#000000'
                        }}
                    />
                </div>
                <button className='bg-black text-white p-3'>
                    Log In
                </button>
            </form>
        </div>
    )
}

export default Login